import { actionCopyDa } from "./actionCopy";

export const analyticsCopyDa = {
    navTitle: "Analyse",
    navDescription: "Analyser data fra dine patienter",
    events: "Begivenheder",
    outcomes: "Resultater",
    rawData: "Rådata",
    searchPatientsPlaceholder: "Søg patienter...",
    searchPatientsAria: "Søg patienter efter navn eller andre felter",
    clearPatientSearchAria: "Ryd patientsøgning",
    editWithAiPlaceholder: "Rediger med AI",
    editWithAiAria: "Rediger med AI",
    stopAiEditAria: "Stop AI",
    downloadCsv: "Download CSV",
    preparingCsv: "Forbereder CSV...",
    downloadSas: "Eksportér til SAS",
    preparingSas: "Forbereder SAS...",
    sasExportHelp: "Download det valgte studie for en datoperiode. Kolonner bruger variabel-OID'er og kodede svar.",
    sasStudy: "Studie",
    sasChooseStudy: "Vælg et studie",
    sasFrom: "Fra",
    sasTo: "Til",
    sasExport: "Eksportér",
    sasDateOrder: "Startdatoen skal være på eller før slutdatoen.",
    sasFailed: "SAS-eksporten mislykkedes. Prøv igen.",
    sasForbidden: "Du har ikke tilladelse til at eksportere dette studie.",
    sasUnmapped: "Dette studie har endnu ingen variabler knyttet til SAS.",
    sasEmpty: "Ingen registreringer i dette studie og denne datoperiode.",
    sasRetry: "Prøv igen",
    columns: actionCopyDa.columns,
    columnVisibilityDiffers: "Kolonnevisning afviger fra standard",
    filter: actionCopyDa.filter,
    addFilter: "Tilføj filter",
    filtersFor: (name: string) => `Filtre for "${name}"`,
    activeFilters: (count: number) => `${count} aktive filtre`,
    edit: actionCopyDa.edit,
    done: actionCopyDa.done,
    shared: "Delt",
    noData: "Ingen data",
    noScoresForFilter: "Ingen scorer for denne filterkombination",
    failedToLoadEvents: "Kunne ikke indlæse begivenheder",
    noEvents: "Ingen begivenheder",
    patients: "Patienter",
    gender: "Køn",
    age: "Alder",
    area: "Område",
    diaryId: "Dagbogs-id",
    patient: "Patient",
    date: "Dato",
    optionsFor: (name: string) => `Valgmuligheder for ${name}`,
    shiftLeft: "Flyt til venstre",
    pieChart: "Cirkeldiagram",
    donutChart: "Donutdiagram",
    barChart: "Søjlediagram",
    lineChart: "Linjediagram",
    sparkCharts: "Spark-diagrammer",
    statsTable: "Statistiktabel",
    statsTableSpark: "Statistiktabel + spark-diagram",
    table: "Tabel",
    stats: "Statistik",
    timepointTable: "Tidspunktstabel",
    histogram: "Histogram",
    changeFromBaseline: "Ændring fra baseline",
    cumulativeEnrolment: "Kumulativ tilmelding",
    engagementRate: "Gennemførelse blandt dem der startede",
    followUpCompletion: "Opfølgningsgennemførelse",
    engagementHint:
        "Andel af startede dagbøger der har gennemført hver opfølgning. Baseline er det første spørgeskema, så det bør ligge tæt på dagbogsstartraten. En sen gennemførelse tæller stadig som gennemført. Dagbøger der aldrig er startet tælles ikke med, og åbne vinduer tælles ikke med.",
    engagementPercentCompleted: "Procent gennemført",
    engagementRateHint:
        "Af patienter der startede spørgeskemaet: gennemført inden for en måned, kun nogle spørgsmål besvaret inden for en måned, eller ikke afsluttet inden for en måned. Patienter der aldrig startede, tælles ikke med.",
    engagementComplete: "Gennemført inden for 1 måned",
    engagementPartial: "Delvist inden for 1 måned",
    engagementNotStarted: "Ikke startet",
    engagementNotWithin: "Ikke inden for 1 måned",
    engagementDue: "Forfalden",
    engagementStarted: "Startet",
    engagementOfPatientsDue: "Procent af patienter med forfalden opfølgning",
    engagementOfPatientsStarted: "Procent af patienter der startede",
    engagementOfDue: (completed: number, due: number) => `${completed} af ${due} forfaldne`,
    engagementLate: "Forsinket",
    engagementMissed: "Misset",
    engagementCompletion: "Gennemførelse",
    engagementAllPatients: "Alle patienter",
    engagementPatientsDue: (n: number) => `${n} forfaldne`,
    engagementHeatmapSplitHint:
        'Vælg "Split by" i diagramindstillingerne for at sammenligne klinikker, etiketter eller klinikere.',
    engagementDotSize: "Punktets størrelse viser hvor mange patienter der var forfaldne.",
    engagementDispositionHint:
        "Hver patient tælles én gang pr. klinisk vindue. Åbne opfølgninger tælles ikke med før de er gennemført eller det tilladte vindue lukker.",
    engagementTimingHint:
        "Dage mellem indsendelse og det planlagte tidspunkt. Punktet er medianforskellen, og bjælken er de midterste 50 %.",
    engagementTimingRangeHint:
        "Nul er det planlagte tidspunkt. Et positivt tal er dage for sent, og et negativt tal er dage for tidligt. Til tiden betyder inden for det tilladte vindue på begge sider af tidspunktet: afstanden til næste opfølgning, fra 1 dag og op til 21 dage.",
    engagementOnTimeCount: (onTime: number, completed: number) => `${onTime} af ${completed} til tiden`,
    engagementTimingWindowColumn: "Tilladt vindue",
    engagementDayWindow: (min: number, max: number) =>
        min === max ? `${min}-dages vindue` : `${min} til ${max} dages vindue`,
    engagementTimingWindowSummary: (min: number, max: number) =>
        min === max ? `Inden for et ${min}-dages vindue` : `Inden for et ${min} til ${max} dages vindue`,
    engagementWithinWindowCount: (onTime: number, completed: number, min: number, max: number) =>
        min === max
            ? `${onTime} af ${completed} inden for et ${min}-dages vindue`
            : `${onTime} af ${completed} inden for et ${min} til ${max} dages vindue`,
    engagementOutsideDayWindow: (n: number, min: number, max: number) =>
        min === max ? `${n} uden for det ${min}-dages vindue` : `${n} uden for det ${min} til ${max} dages vindue`,
    engagementOutsideWindow: (n: number, window?: string) =>
        window ? `${n} uden for vinduet (${window})` : `${n} uden for vinduet`,
    engagementWindowDays: (min: number, max: number) =>
        min === max ? `±${min} ${min === 1 ? "dag" : "dage"}` : `±${min} til ${max} dage`,
    engagementOutsideWindowColumn: "Uden for vinduet",
    engagementGapDays: (days: number) => {
        const rounded = Math.round(days * 10) / 10;
        const unit = Math.abs(rounded) === 1 ? "dag" : "dage";
        if (rounded === 0) return `0 ${unit}`;
        return `${rounded > 0 ? "+" : ""}${rounded} ${unit}`;
    },
    engagementTimingAxisDays: (days: number) => {
        if (days === 0) return "0";
        const unit = Math.abs(days) === 1 ? "dag" : "dage";
        return `${days > 0 ? "+" : ""}${days} ${unit}`;
    },
    engagementTimingEmpty: "Ingen gennemførte planlagte opfølgninger har tidsdata",
    engagementEarlier: "Tidligere",
    engagementScheduled: "Planlagt",
    engagementLater: "Senere",
    engagementMedian: "Median",
    engagementCompleted: "Fuldført",
    engagementMiddle50: "Midterste 50%",
    engagementCompletedCount: (n: number) => `${n} gennemført`,
    engagementMetrics: "Engagementsmål",
    engagementMetricsHint:
        "Registrerings- og dagbogsgennemførelse bruger patientspørgeskemaer i dagbøger der er startet. Dagbogsgennemførelse tælles ud af de startede dagbøger. Klinikerskemaer tælles ikke med.",
    engagementMetric: "Mål",
    engagementRateColumn: "Frekvens",
    engagementCount: "Antal",
    engagementOnTimeRate: "Frekvens til tiden",
    engagementDiaryStartRate: "Startfrekvens for dagbøger",
    engagementEntryCompletionRate: "Gennemførelsesgrad for registreringer",
    engagementDiaryCompletionRate: "Gennemførelsesgrad for dagbøger",
    engagementDiariesStarted: (completed: number, due: number) => `${completed} af ${due} dagbøger startet`,
    engagementEntriesCompleted: (completed: number, due: number) => `${completed} af ${due} registreringer gennemført`,
    engagementDiariesCompleted: (completed: number, due: number) => `${completed} af ${due} dagbøger gennemført`,
    engagementWindows: {
        baseline: "Baseline",
        w6: "Op til 6 uger",
        m3: "6 uger til 3 måneder",
        m6: "3 til 6 måneder",
        m12: "6 til 12 måneder",
        m12plus: "Over 12 måneder",
    } as Record<string, string>,
    engagementAllCompleted: "Helt udfyldt",
    engagementSomeCompleted: "Delvist udfyldt",
    engagementNoneStarted: "Ingen opfølgninger er startet endnu",
    engagementOnTime: "Til tiden",
    engagementUnderMonth: "Mindre end 1 måned for sent",
    engagementOverMonth: "Mere end 1 måned for sent",
    engagementEmpty: "Ingen planlagte opfølgninger er forfaldne endnu",
    engagementPatient: "Patient",
    engagementClinician: "Kliniker",
    engagementCohort: "Kohorte",
    engagementByLabel: "Dagbogsetiket",
    engagementByClinician: "Kliniker",
    engagementByTracker: "Spørgeskema",
    engagementFollowUp: "Opfølgning",
    engagementFollowUpGrain: "Tidspunkt",
    engagementFollowUpAbsolute: "Absolut",
    engagementFollowUpGrouped: "Grupperet",
    engagementFollowUpDaily: "Dagligt",
    engagementFollowUpWeekly: "Ugentligt",
    engagementFollowUpMonthly: "Månedligt",
    engagementFollowUpQuarterly: "Kvartalsvis",
    engagementFollowUpYearly: "Årligt",
    engagementFollowUpDays: "Dage",
    engagementFollowUpWeeks: "Uger",
    engagementFollowUpMonths: "Måneder",
    engagementFollowUpYears: "År",
    engagementFollowUpAbsoluteHint: "Hver opfølgning vises som sit eget punkt, i skemaets rækkefølge.",
    engagementFollowUpGroupedHint: "Grupperet viser Måned 0, Måned 1, Måned 2. Måned 0 er de første 30 dage.",
    engagementFollowUpStep: (grain: "day" | "week" | "month" | "quarter" | "year", index: number) => {
        const label =
            grain === "day"
                ? "Dag"
                : grain === "week"
                  ? "Uge"
                  : grain === "month"
                    ? "Måned"
                    : grain === "quarter"
                      ? "Kvartal"
                      : "År";
        return `${label} ${index}`;
    },
    engagementFollowUpGrainHint: (grain: "day" | "week" | "month" | "quarter" | "year") => {
        if (grain === "day") return "Dagligt viser Dag 0, Dag 1, Dag 2. Dag 0 er proceduredagen.";
        if (grain === "week") return "Ugentligt viser Uge 0, Uge 1, Uge 2. Uge 0 er de første 7 dage.";
        if (grain === "quarter")
            return "Kvartalsvis viser Kvartal 0, Kvartal 1, Kvartal 2. Kvartal 0 er de første 90 dage.";
        if (grain === "year") return "Årligt viser År 0, År 1, År 2. År 0 er det første år.";
        return "Månedligt viser Måned 0, Måned 1, Måned 2. Måned 0 er de første 30 dage.";
    },
    engagementGroupAria: "Engagement-opdeling",
    engagementOf: (completed: number, due: number) => `${completed} af ${due}`,
    unlabelled: "Uden etiket",
    unassigned: "Ikke tildelt",
    timepoint: "Tidspunkt",
    ageBracket: "Aldersgruppe",
    label: "Dagbogsmærkat",
    sex: "Køn",
    anatomicArea: "Anatomisk område",
    event: "Begivenhed",
    form: "Spørgeskema",
    averageAge: "Gennemsnitsalder",
    patientCountsByAgeBracket: "Patienttal efter aldersgruppe",
    ageDistribution: "Aldersfordeling",
    chartOfGender: (chart: string) => `${chart} efter køn`,
    patientCountsByGender: "Patienttal efter køn",
    totalPatients: "Patienter i alt",
    meanField: (field: string) => `Gennemsnit ${field}`,
    formStats: (form: string) => `${form} statistik`,
    tableOf: (dataset: string) => `Tabel over ${dataset}`,
    sparkChartsOf: (form: string) => `Spark-diagrammer af ${form}`,
    statsTableOf: (form: string) => `Statistiktabel for ${form}`,
    statsTableByTimepoint: (form: string) => `Statistiktabel for ${form} efter tidspunkt`,
    statsTableSparkOf: (form: string) => `Statistiktabel + spark-diagram for ${form}`,
    statsTableSparkByTimepoint: (form: string) => `Statistiktabel + spark-diagram for ${form} efter tidspunkt`,
    lineChartOverTime: (form: string) => `Linjediagram af ${form} over tid`,
    byTimepoint: (form: string) => `${form} efter tidspunkt`,
    histogramOf: (subject: string) => `Histogram af ${subject}`,
    previousTreatments: (form: string) => `Tidligere behandlinger · ${form}`,
    patientCountsBy: (group: string) => `Patienttal efter ${group}`,
    barChartOfBy: (subject: string, group: string) => `Søjlediagram af ${subject} efter ${group}`,
    chartOf: (chart: string, subject: string) => `${chart} af ${subject}`,
    chartOfBy: (chart: string, dataset: string, field: string) => `${chart} af ${dataset} efter ${field}`,
    bySuffix: (title: string, split: string) => `${title} efter ${split}`,
    changeFromBaselineSubject: (subject: string) => `Ændring fra baseline · ${subject}`,
    lsmeanChange: (subject: string) => `LSMean-ændring · ${subject}`,
    percentOfMax: (subject: string) => `% af maksimum · ${subject}`,
    percentChangeFromBaseline: (subject: string) => `% ændring fra baseline · ${subject}`,
    score: "Score",
    shiftRight: "Flyt til højre",
    rename: actionCopyDa.rename,
    duplicate: actionCopyDa.duplicate,
    share: actionCopyDa.share,
    delete: actionCopyDa.delete,
    cancel: actionCopyDa.cancel,
    addView: "Tilføj visning",
    addViewDescription: "Vælg først et diagramdashboard eller et rådataark.",
    addViewStepOf: (step: number, total: number) => `Trin ${step} af ${total}`,
    addViewStepTypeTitle: "Hvilken slags visning?",
    addViewStepTypeDescription:
        "Vælg et diagramdashboard eller et rådataark. Du kan kopiere indstillinger og spørge AI i næste trin.",
    addViewStepSetupTitle: "Kopier indstillinger eller spørg AI",
    addViewStepSetupDescription:
        "Valgfrit. Kopier filtre fra en anden fane, beskriv hvad du vil have, eller begge dele.",
    addViewBack: "Tilbage",
    addViewAiLabel: "Spørg AI",
    addViewAiPlaceholderCharts: "Valgfrit: beskriv diagrammerne, f.eks. WOMAC over tid efter alder",
    addViewAiPlaceholderData: "Valgfrit: beskriv filtre, f.eks. knædagbøger for patienter over 60",
    copySettingsFrom: "Kopier indstillinger fra",
    none: actionCopyDa.none,
    charts: "Diagrammer",
    data: "Data",
    chartsDescription: "Widgets, tendenser og nøgletal",
    dataDescription: "Regneark med patientrækker og scorer",
    createChartsView: "Opret diagramvisning",
    createDataView: "Opret datavisning",
    refreshAria: "Opdater analysedata",
    addWidget: "Tilføj widget",
    addWidgetFor: (name: string) => `Vælg et spørgeskema, et valgfrit felt og visningen for "${name}".`,
    noWidgetsOnTab: "Ingen widgets på denne fane endnu.",
    useAddWidgetToChart: (label: string) => `Brug "Tilføj widget" ovenfor til at vise rigtige ${label}-data.`,
    diaryFallback: "dagbog",
    failedToLoadAnalytics: "Kunne ikke indlæse analysedata",
    failedToLoadData: "Kunne ikke indlæse data",
    failedToLoadPatientData: "Kunne ikke indlæse patientdata. Opdater for at prøve igen.",
    loadingPatients: "Indlæser patienter...",
    loadingAnalytics: (label: string) => `Indlæser ${label}-data...`,
    analyticsFallback: "analyser",
    fieldFallback: "Felt",
    noWidgetsYet: "Ingen widgets endnu. Tilføj en fra paletten, eller spørg AI-assistenten.",
    noWidgetsConfigured: "Der er ingen widgets konfigureret til denne visning.",
    clearFilters: "Ryd filtre",
    deleteViewTitle: "Slet visning?",
    deleteViewDescription: (name: string) =>
        `Dette fjerner "${name}" og dens widgets permanent. Det kan ikke fortrydes.`,
    showingRangeOf: (start: string, end: string, total: string, noun: string) =>
        `Viser ${start}-${end} af ${total} ${noun}`,
    rowSingular: "række",
    rowPlural: "rækker",
    diarySingular: "dagbog",
    diaryPlural: "dagbøger",
    noPatientsMatch: (query: string) => `Ingen patienter matcher "${query}"`,
    noPatientsMatchFilters: "Ingen patienter matcher de aktuelle filtre",
    searchColumnsPlaceholder: "Søg kolonner...",
    searchColumnsAria: "Søg kolonner",
    visibleColumns: "Synlige kolonner",
    showAll: "Vis alle",
    hideAll: "Skjul alle",
    eventsCount: "begivenheder",
    acrossDiaries: (count: number) => `På tværs af ${count} ${count === 1 ? "dagbog" : "dagbøger"}`,
    eventPrefix: (label: string) => `Begivenhed · ${label}`,
    chartSettings: "Diagramindstillinger",
    severalDataTabsHint:
        "Du har allerede flere datafaner - overvej at justere filtre eller kolonner på en eksisterende fane.",
    chartN: (n: number) => `Diagram ${n}`,
    dataN: (n: number) => `Data ${n}`,
    showingColumnsOf: (visible: string, total: string) => `Viser ${visible} af ${total} kolonner`,
    noColumnsMatch: (query: string) => `Ingen kolonner matcher "${query}"`,
    filterCategories: {
        mine: "Min rolle",
        demographic: "Demografi",
        label: "Dagbogsmærkat",
        org: "Organisation",
        form: "Spørgeskema",
        event: "Hændelse",
        status: "Dagbogsstatus",
    },
    filterAnnotations: {
        mine: "Dagbøger, hvor du har en af disse roller.",
        label: "Dagbøger med et af disse mærkater.",
        org: "Dagbøger i en af disse organisationer.",
        status: "Dagbøger med en af disse statusser.",
    },
    filteredBy: "Filtreret efter",
    sexValues: { Female: "Kvinde", Male: "Mand", Other: "Ukendt" },
    rawCellExplanations: {
        genderInferred:
            "Køn udledes af titlen i patientnavnet (f.eks. hr., fru). Rediger kolonnen Navn for at ændre det.",
        genderPrivate:
            "Køn er en kohortedemografi udledt af titlen (f.eks. hr., fru). Navnet forbliver privat for dit adgangsniveau.",
        patientNamePrivate: "Patientnavnet er privat for dit adgangsniveau.",
        patientNameHidden: "Patientnavnet er skjult uden adgang til identificerbare oplysninger.",
        dobPrivate: "Fødselsdatoen er privat for dit adgangsniveau.",
        ageEditable:
            "Alder ved dagbogens startdato, beregnet ud fra fødselsdatoen – ikke patientens alder i dag. Rediger fødselsdatoen for at ændre den.",
        agePrivate:
            "Alder ved dagbogens startdato, beregnet ud fra fødselsdatoen – ikke patientens alder i dag. Fødselsdatoen forbliver privat for dit adgangsniveau.",
        ageReadonly: "Alder ved dagbogens startdato, beregnet ud fra fødselsdatoen – ikke patientens alder i dag.",
        sideDerived: "Hvilken side spørgeskemaerne på denne række vedrører. Vælg begge, hvis begge sider er berørt.",
        noQuestionnaireSide: "Der er intet spørgeskema på denne række at angive side for.",
        noEditableEvent: "Der er ingen redigerbar hændelse i denne dagbog.",
        unsupportedEventValue: "Denne værdi understøttes ikke af hændelsens redigeringsformular.",
        productArea: "Området bestemmes af det valgte produkt. Rediger produktcellen for at ændre det.",
        noEventDate: "Der er ingen hændelsesdato at redigere i denne dagbog.",
        noEditableArea: "Ingen redigerbar hændelse angiver dette område.",
        shockwaveProcedure: "Stødbehandling er behandlingstypen, ikke en redigerbar detalje.",
        noEditableProcedure: "Ingen redigerbar hændelse angiver denne behandling.",
        ageDerived: "Alder ved dagbogens startdato, beregnet ud fra fødselsdatoen. Ikke patientens aktuelle alder.",
        durationDerived: "Beregnet fra dagbogens startdato til i dag.",
        ageAtEventDerived: (event: string) => `Beregnet ud fra fødselsdatoen og den tidligste dato for ${event}.`,
        noTracker: "Der er intet spørgeskema på dette tidspunkt for denne dagbog.",
        noSideTracker: (side: string) => `Der er intet spørgeskema (${side}) på dette tidspunkt for denne dagbog.`,
        notOnSchedule: "Dette tidspunkt findes ikke i spørgeskemaets tidsplan.",
        notOnSideSchedule: (side: string) => `Dette tidspunkt findes ikke i tidsplanen for spørgeskemaet (${side}).`,
        multipleEventRows: (event: string) =>
            `Denne hændelse (${event}) har flere detaljelinjer. Rediger den i patientdagbogen for at undgå at erstatte de andre detaljer.`,
        multipleEvents: (event: string) =>
            `Flere hændelser (${event}) bidrager til denne celle. Rediger dem i patientdagbogen.`,
        multipleDates: (event: string) =>
            `Flere datoer (${event}) bidrager til denne celle. Rediger dem i patientdagbogen.`,
        editDobHelper: "Alder ved dagbogens start beregnes ud fra denne fødselsdato.",
        editEventDateHelper: (event: string) => `Rediger datoen for ${event}.`,
    },
    eventDatasetLabels: {
        injection: "Injektioner",
        surgery: "Operationer",
        shockwave: "Stødbehandlinger",
        product: "Produkter",
        education: "Konsultationer",
        medication: "Medicineringer",
    } as Record<string, string>,
    rawSideValues: { left: "venstre", right: "højre", both: "begge", middle: "midt" } as Record<string, string>,
    showDetailsAria: "Vis detaljer",
    widgetTypes: {
        stat: "Statistikkort",
        bar: "Søjle",
        histogram: "Histogram",
        donut: "Ring",
        pie: "Cirkel",
        line: "Linje/område",
        spark: "Mini-diagrammer",
        statsTable: "Statistiktabel",
        statsTableSpark: "Statistiktabel + spark-diagram",
        diaryStatus: "Dagbogsstatus",
        timepoints: "Tidspunktstabel",
        table: "Tabel",
        enrolment: "Kumulativ tilmelding",
        engagement: "Opfølgningsgennemførelse",
        engagementTable: "Opfølgningstabel",
        engagementRate: "Blandt dem der startede",
        engagementDisposition: "Patientforløb",
        engagementTiming: "Tidspunkt i forhold til planen",
        engagementRetention: "Fastholdelseskurve",
        engagementKpi: "Nøgletal",
        engagementHeatmap: "Varmekort efter opdeling",
        engagementDots: "Punktdiagram",
    },
    valueTransforms: {
        absolute: "Absolut",
        changeFromBaseline: "Ændring fra baseline",
        lsmeanChange: "LSMean-ændring",
        percentOfMax: "% af maksimum",
        percentChangeFromBaseline: "% ændring fra baseline",
    },
    summaryTable: {
        unknownForm: "Ukendt spørgeskema",
        noEntries: "Ingen besvarelser",
        metric: "Måling",
        distribution: "Fordeling",
        boxPlot: "Boksplot",
        mean: "Gennemsnit",
        median: "Median",
        mode: "Typetal",
        sd: "SD",
        ci: "95% CI",
        frequency: "Hyppighed",
        value: "Værdi",
        count: "Antal",
        percent: "%",
        indicator: "Indikator",
        proportion: "Andel",
        entries: "Besvarelser",
        yes: "Ja",
        no: "Nej",
    },
    rawColumnGroups: {
        Patient: "PATIENT",
        INJECTION: "INJEKTION",
        SURGERY: "OPERATION",
        SHOCKWAVE: "STØDBEHANDLING",
        PRODUCT: "PRODUKT",
        CONSULTATION: "KONSULTATION",
    } as Record<string, string>,
    rawFieldLabels: {
        Date: "Dato",
        Substance: "Stof",
        Area: "Område",
        Site: "Sted",
        Side: "Side",
        Dose: "Dosis",
        Type: "Type",
        Procedure: "Indgreb",
        Product: "Produkt",
        Topic: "Emne",
        "Provided by": "Leveret af",
        "Delivered by": "Udført af",
        "Referring clinician": "Henvisende kliniker",
        "Injecting clinician": "Injicerende kliniker",
        "Operating clinician": "Opererende kliniker",
        "Shockwaving clinician": "Stødbehandlende kliniker",
    } as Record<string, string>,
    rawColumnLabels: {
        diary_id: "Dagbogs-id",
        patient_name: "Navn",
        date_of_birth: "Fødselsdato",
        age: "Alder",
        gender: "Køn",
        organisation: "Organisation",
        side: "Side",
        area: "Område",
        procedure: "Behandling",
    } as Record<string, string>,
    scoreUnavailable: "Ikke tilgængelig",
    scoreAdd: "Tilføj score",
    scoreNotDueYet: "Ikke forfaldet endnu",
    scoreLate: "Forsinket",
    scoreClickToAddTooltip: "Klik på cellen for at tilføje en score",
    scoreLateTooltip: "Dette tidspunkt er forsinket. Klik på cellen for at tilføje en score.",
    scoreNotDueTooltip: "Dette tidspunkt er ikke forfaldet endnu. Klik på cellen for at tilføje en score.",
    scoreNoTrackerTooltip: "Intet spørgeskema på dette tidspunkt for denne dagbog.",
    editScore: "Rediger score",
    decreaseScoreAria: "Reducer score",
    increaseScoreAria: "Øg score",
    scoreRange: (min: number, max: number) => `Interval ${min} - ${max}`,
    scoreMin: (min: number) => `Min. ${min}`,
    scoreMax: (max: number) => `Maks. ${max}`,
    confidential: "Fortroligt",
    confidentialAria: "Fortrolige patientoplysninger. Vis hvorfor.",
    thisTimepoint: "Dette tidspunkt",
    dueDate: (date: string) => `Forfalder ${date}`,
    enteredDate: (date: string) => `Indtastet ${date}`,
    entryNotEnteredYet: "Endnu ikke indtastet",
    timepointHasRecordedScore: (point: string) => `${point} har en registreret score.`,
    timepointDates: (point: string, dates: string) => `${point}: ${dates}.`,
    timepointNoTracker: (point: string) =>
        `${point} har intet spørgeskema på denne dagbog, så en score kan ikke tilføjes.`,
    clickToAddScore: "Klik for at tilføje en score.",
    diaryStatus: "Dagbogsstatus",
    diaryStatusTable: {
        searchPlaceholder: "Søg på patientnavn",
        searchAria: "Søg patienter",
        clearSearch: "Ryd søgning",
        columns: "Kolonner",
        columnsDescription:
            "Vælg hvilke kolonner der vises. Brug kontakten på en gruppe til at vise eller skjule alle kolonner i den. Navn og fødselsdato er skjult, indtil du slår dem til.",
        sparkline: "Sparkline",
        patientDetails: "Patientoplysninger",
        reset: "Nulstil",
        save: "Gem",
        questionnaire: "Spørgeskema",
        patient: "Patient",
        patientName: "Patientnavn",
        dateOfBirth: "Fødselsdato",
        score: "Score",
        status: "Status",
        startDate: "Startdato",
        organisation: "Organisation",
        labels: "Etiketter",
        age: "Alder",
        sex: "Køn",
        area: "Område",
        procedure: "Indgreb",
        noPatients: "Ingen patienter matcher disse filtre.",
        loading: "Indlæser patienter...",
        unknownPatient: "Ukendt patient",
        showing: (from: string, to: string, total: string): string => `Viser ${from}-${to} af ${total}`,
    },
};
